import * as React from "react";
import OWQuestions from "./OWQuestions";
import { IQuestionGroup } from "../models";
import { ILineItemInfo, IUserPreferences } from "../interfaces";
import WizardHelper from "../WizardHelper";
import { useTranslations } from "@fenetech/translations";
import { Flag } from "@mui/icons-material";
import { TabContext, TabPanel } from "@mui/lab";
import { Grid, Tab } from "@mui/material";
import CustomTabList from "components/Common/CustomTabList";
import ItemPropertiesSelector from "../ItemProperties/ItemPropertiesSelector";

export interface IOWTabsProps {
    questionGroups: Array<IQuestionGroup>;
    preferences: IUserPreferences;
    readOnlyMode: boolean;
    itemInfo: ILineItemInfo | null;
    showItemProperties: boolean;
}

const OWTabs: React.FC<IOWTabsProps> = (props: IOWTabsProps) => {

    const SIZE_STRING: string = "TAB_SIZE"
    const tm = useTranslations();
    const [currentTab, setCurrentTab] = React.useState<string>(props.showItemProperties ? SIZE_STRING : props.questionGroups[0].groupName);

    return <TabContext value={currentTab} >

        <CustomTabList variant="scrollable" scrollButtons="auto" onChange={(e, newValue) => setCurrentTab(newValue)} sx={{ position: "sticky", top: "40px", zIndex: 40, maxWidth: "1000px" }}    >
            {props.showItemProperties &&
                <Tab
                    key={SIZE_STRING}
                    value={SIZE_STRING}
                    label={tm.Get("ITEM")}
                />
            }

            {props.questionGroups.map((qg: IQuestionGroup, index) =>
                <Tab key={`TBL_${index}_${qg.groupName}`}
                    value={qg.groupName}
                    label={<Grid container>
                        {(WizardHelper.RecursivelyIsThereARequiredQuestionOrCode(qg.questions)) && <Grid item xs="auto"><Flag sx={{ width: "16px", height: "16px" }} color="warning" /></Grid>}
                        {<Grid item xs>{qg.groupName}</Grid>}
                    </Grid>}
                />
            )}
        </CustomTabList>

        {props.showItemProperties &&
            <TabPanel sx={{ padding: 0, marginTop: 1 }}
                key={SIZE_STRING}
                value={SIZE_STRING}
            >
                <ItemPropertiesSelector />
            </TabPanel>
        }

        {props.questionGroups.map((qg: IQuestionGroup, index) => (
            <TabPanel key={`TBPL_${index}_${qg.groupName}`} value={qg.groupName} sx={{ padding: 0, marginTop: 1 }}>
                <OWQuestions
                    preferences={props.preferences}
                    questionGroup={qg}
                    readOnlyMode={props.readOnlyMode}
                />
            </TabPanel>
        ))}

    </TabContext>;

};

export default OWTabs;
